import React from 'react';
import { usePagination, useStats, useSearchBox } from 'react-instantsearch';

export const SearchStatsGlobal = () => {
    const { currentRefinement } = usePagination();
    const { hitsPerPage, nbHits, nbSortedHits } = useStats();
    const { query } = useSearchBox();
    const hitCount = nbSortedHits || nbHits;

    if (hitCount === 0) {
        return null;
    }

    const paginationLimit = Number(process.env.ALGOLIA_PAGINATION_LIMIT);
    const totalCount = hitCount > paginationLimit ? paginationLimit : hitCount;
    const totalCountText = totalCount.toLocaleString('en') + (hitCount > paginationLimit ? '+' : '');
    const rangeStart = ((currentRefinement + 1) * hitsPerPage - hitsPerPage + 1).toLocaleString('en');
    let rangeEnd = (currentRefinement + 1) * hitsPerPage;

    if (rangeEnd > totalCount) {
        rangeEnd = totalCount;
    }

    rangeEnd = rangeEnd.toLocaleString('en');

    return (
        <span className="font-normal font-sans text-secondary">
            {`Displaying ${rangeStart}-${rangeEnd} of ${totalCountText} results`}
            {query && (
                <>
                    {' for “'}
                    <strong>{query}</strong>”
                </>
            )}
        </span>
    );
};
